import React, { useState, useEffect, useMemo } from "react";
import "./NewEmbedPage.scss";
import { useParams } from "react-router-dom";
import { Err404 } from "../../Pages/Error/Error404.js";
import EmbedPageFooter from "./Footer/EmbedPageFooter.js";
import SidePanel from "./SidePanel/SidePanel.js";
import CarouselForms from "./CarouselForms/CarouselForms.jsx";
import SingleForm from "./SingleForm/SingleForm.js";
import useMediaQueries from "../../../hooks/useMediaQueries.js";
import { useContent } from "../../../contexts/contentContext/contentContext.js";
import Image from "../../Elements/Image/Image.tsx";
import normalizeDomain from "./Helpers/getNormalizeDomain.ts";
import OrderTrackerScript from "../../Reusable/OrderTrackerScript/OrderTrackerScript.js";
import { useModal } from "../../../contexts/modalContext/modalContext.js";
import queryString from "query-string";
import { useLocation } from "react-router-dom";
import {
  embedColorCode,
  defaultFormImages,
  defaultBackgrounds,
} from "components/Reusable/JUMBOform/ExternalJsonsList/JsonLists.js";
import {
  getRandomInt,
  GetEmbedDynamicPageForDisplay,
} from "../EditEmbedPage/Helpers/ApiCalles.js";
import UpdateScripts from "./Helpers/UpdateScripts.js";
import LoadingContainerElement from "components/Elements/LoadingContainerElement/LoadingContainerElement.js";
import { listSocial } from "./Helpers/JsonListsEmbedPage.js";
import getAsyncImage from "utils/getAsyncImage.js";
import useBucketName from "hooks/useBucketName.ts";
import { DOMAIN_NAME } from "utils/globalConsts.ts";

const NewEmbedPage = () => {
  const { setModal } = useModal();
  const location = useLocation();
  const {
    getDirection,
    getTextByKey,
    getPath,
    getLanguage,
    fetchOrderTrackerConsts,
  } = useContent();
  const params = useParams();
  const { leptopCondition, desktopCondition } = useMediaQueries();
  const [FullDetailsEmbedPage, setFullDetailsEmbedPage] = useState(null);
  const [loading, setLoading] = useState(false);
  const [backgroundImageListURLS, setBackgroundImageListURLS] = useState([]);
  const [userNamePage, setUserNamePage] = useState(null);
  const [diractionPage, setDiractionPage] = useState(getDirection());
  const [backgroundImagesList, setBackgroundImagesList] = useState(null);
  const [pageLanguage, setPageLanguage] = useState(getLanguage());
  const [displayFormDetialsDB, setDisplayFormDetialsDB] = useState(false);
  const [displayFormDetails, setDisplayFormDetails] =
    useState(displayFormDetialsDB);
  useEffect(() => {
    if (window.innerWidth > desktopCondition) {
      setDisplayFormDetails(displayFormDetialsDB);
    } else {
      setDisplayFormDetails(true);
    }
  }, [displayFormDetialsDB, desktopCondition]);

  //background settings:
  const [isDefaultBackgrounds, setIsDefaultBackgrounds] = useState(false);
  const [randomBackground, setRandomBackground] = useState(null);
  const [brandingColor, setBrandingColor] = useState(embedColorCode);
  //Seo
  const [formSelected, setFormSelected] = useState(null);
  const [formList, setFormList] = useState([]);
  const [showCloseButton, setShowCloseButton] = useState(false);
  const [openSidePanel, setOpenSidePanel] = useState(true);
  const [closeDescriptionMobile, setCloseDescriptionMobile] = useState(false);
  //Single Form:
  const [formDetails, setFormDetails] = useState(null);
  const [displaySidePanel, setDisplaySidePanel] = useState(true);
  const [embedIframe, setEmbedIframe] = useState(null);

  const [loadImageBackground, setLoadImageBackground] = useState(false);
  const [formImagesLoaded, setFormImagesLoaded] = useState(0);
  const [isFormImagesLoaded, setIsFormImagesLoaded] = useState(false);
  const [formImages, setFormImages] = useState([]);
  const [singleForm, setSingleForm] = useState(false);
  const [numOfSocialLinks, setNumOfSocialLinks] = useState(0);
  const baseUrl = window.location.origin.includes("localhost")
    ? `http://localhost:3000`
    : window.location.origin.includes("jumbomail") ||
      window.location.origin.includes("jmbl")
    ? window.location.origin
    : `https://${DOMAIN_NAME}`;
  const [linkFooters, setLinkFooters] = useState([
    {
      FooterLinkTitle: getTextByKey("about-footer"),
      FooterLinkUrl: baseUrl + getPath() + "jumbo-forms",
    },
    {
      FooterLinkTitle: getTextByKey("support-footer"),
      FooterLinkUrl: baseUrl + getPath() + "support/jumbo-embed",
    },
    {
      FooterLinkTitle: getTextByKey("terms-footer"),
      FooterLinkUrl: baseUrl + getPath() + "terms",
    },
  ]);

  const userId =
    FullDetailsEmbedPage?.EmbedDynamicPage?.EmbedPageEncryptedUserId || "";

  const bucketName = useBucketName({
    userId,
  });

  useEffect(() => {
    if (
      bucketName &&
      normalizeDomain(bucketName) !==
        normalizeDomain(window.location.hostname) &&
      userId
    ) {
      window.location.href = `https://${bucketName}${window.location.pathname}`;
    }
  }, [userId, bucketName]);

  useEffect(() => {
    if (location.search.includes("form")) {
      const formId = queryString.parse(location.search).form;
      setFormSelected(formId);
    }
  }, []);

  useEffect(() => {
    if (formSelected && formList.length > 1) {
      window.history.pushState({}, "", "?form=" + formSelected);
    } else {
    }
  }, [formSelected]);

  const clearFormDetails = () => {
    setFormSelected(null);
    setEmbedIframe(null);
    setFormDetails(null);
    window.history.pushState({}, "", getPath() + "page/" + userNamePage);
  };

  //------------------------------------------------------------------------
  //---------------------------------TEMP SOLUTION--------------------------
  //------------------------------------------------------------------------

  useEffect(() => {
    const RADWARE_PAGE_NAME = "radware-filepile";
    const RADWARE_HOST_NAME = "fileshare.radware.com";
    if (
      window.location.pathname.includes(RADWARE_PAGE_NAME) &&
      !window.location.hostname.includes(RADWARE_HOST_NAME)
    ) {
      window.location.href = `https://${RADWARE_HOST_NAME}${getPath()}page/${RADWARE_PAGE_NAME}`;
    }
  }, [getPath()]);

  //------------------------------------------------------------------------
  //---------------------------------TEMP SOLUTION--------------------------
  //------------------------------------------------------------------------

  useEffect(() => {
    if (formList.length > 0) {
      if (formSelected) {
        setShowCloseButton(true);
      } else {
        setShowCloseButton(false);
      }
    } else if (formList.length === 1) {
      setShowCloseButton(false);
    }
  }, [formList, formSelected]);

  useEffect(() => {
    if (formList.length === 1) {
      setOpenSidePanel(true);
      setCloseDescriptionMobile(false);
      //setFormSelected(formList[0].EmbedPageFormId);
    }
  }, [formList]);

  useMemo(() => {
    if (formSelected) {
      if (desktopCondition) {
        setOpenSidePanel(false);
      } else {
        setCloseDescriptionMobile(true);
      }
    } else {
      setCloseDescriptionMobile(false);
    }
  }, [desktopCondition, formSelected, leptopCondition]);

  useEffect(() => {
    if (params) {
      if (params.EmbedPageUserName && params.EmbedPageUserName !== undefined) {
        GetEmbedDynamicPageForDisplay({
          setLoading: setLoading,
          setFullDetailsEmbedPage: setFullDetailsEmbedPage,
          userName: params.EmbedPageUserName,
          setLoadImageBackground,
          setIsFormImagesLoaded,
          lang: getLanguage(),
          setPageLanguage,
        });
        setUserNamePage(params.EmbedPageUserName);
        if (params.EmbedDynamicId && params.EmbedDynamicId !== undefined) {
          setFormSelected(params.EmbedDynamicId);
        }
      }
    }
  }, [params.EmbedPageUserName, params.EmbedDynamicId]);

  useEffect(() => {
    fetchOrderTrackerConsts({ language: pageLanguage });
  }, [pageLanguage]);
  //Background images:

  const newChangeBackgroundImage = ({ random }) => {
    if (random) {
      const randomNum = getRandomInt(backgroundImageListURLS.length);
      setRandomBackground(backgroundImageListURLS[randomNum]);
    } else {
      setRandomBackground(backgroundImageListURLS[0]);
    }
  };

  //if background type is randon - display random background
  useEffect(() => {
    if (
      FullDetailsEmbedPage &&
      FullDetailsEmbedPage.EmbedDynamicPage &&
      backgroundImageListURLS.length > 0
    ) {
      newChangeBackgroundImage({
        random:
          FullDetailsEmbedPage.EmbedDynamicPage.EmbedPageBackgroundDisplay ===
          "Random",
      });
    }
  }, [FullDetailsEmbedPage, backgroundImageListURLS]);

  useEffect(() => {
    if (backgroundImagesList) {
      if (backgroundImagesList.length > 0) {
        const urlImagesList = backgroundImagesList.map((item) => item.ImageSrc);
        setBackgroundImageListURLS(urlImagesList);
        setIsDefaultBackgrounds(false);
      } else {
        setBackgroundImageListURLS(defaultBackgrounds);
        setIsDefaultBackgrounds(true);
      }
    }
  }, [backgroundImagesList]);

  useEffect(() => {
    if (FullDetailsEmbedPage) {
      if (FullDetailsEmbedPage.EmbedDynamicPage) {
        setDiractionPage(
          FullDetailsEmbedPage.EmbedDynamicPage.EmbedPageDirection &&
            FullDetailsEmbedPage.EmbedDynamicPage.EmbedPageDirection
        );
        setBrandingColor(
          FullDetailsEmbedPage.EmbedDynamicPage.EmbedDynamicPageBrandingColor
            ? FullDetailsEmbedPage.EmbedDynamicPage
                .EmbedDynamicPageBrandingColor
            : embedColorCode
        );
        if (FullDetailsEmbedPage.EmbedDynamicPage.FooterLinks) {
          setLinkFooters(FullDetailsEmbedPage.EmbedDynamicPage.FooterLinks);
        }
        setDisplayFormDetialsDB(
          FullDetailsEmbedPage.EmbedDynamicPage
            .EmbedDynamicPageDisplayFormDetails
        );
        setDisplaySidePanel(
          FullDetailsEmbedPage.EmbedDynamicPage.EmbedDynamicPageDisplaySidePanel
        );
      }
      if (FullDetailsEmbedPage.EmbedDynamicPageFormList) {
        if (FullDetailsEmbedPage.EmbedDynamicPageFormList.length > 0) {
          let count = 0;
          let tempForm = null;
          let tempListForm = [];
          let tempFormImages = [];
          FullDetailsEmbedPage.EmbedDynamicPageFormList.forEach((element) => {
            const callBackImage = (image) => {
              let tempForm = element;
              tempForm.EmbedPageFormImage = image;
              tempListForm.push(tempForm);
              if (!element.EmbedPageFormImageUrl) {
                count++;
              }
            };
            if (!element.EmbedPageFormImage && !element.EmbedPageFormImageUrl) {
              getAsyncImage(
                `images/${defaultFormImages[count]}.webp`,
                callBackImage
              );
            } else if (element.EmbedPageFormImageUrl) {
              getAsyncImage(
                `images/personal/form-images/webp/${element.EmbedPageFormImageUrl}.webp`,
                callBackImage
              );
            } else {
              tempListForm.push(element);
              tempFormImages.push(element.EmbedPageFormImage);
            }
          });
          setFormImages(tempFormImages);
          setFormList(tempListForm);

          if (FullDetailsEmbedPage.EmbedDynamicPageFormList.length === 1) {
            setFormSelected(
              FullDetailsEmbedPage.EmbedDynamicPageFormList[0].EmbedPageFormId
            );
            setSingleForm(true);
          }
        }
      }
      setBackgroundImagesList(
        FullDetailsEmbedPage.EmbedDynamicPageImageList
          ? FullDetailsEmbedPage.EmbedDynamicPageImageList
          : []
      );

      let numOfSocials = 0;
      listSocial.forEach((element) => {
        if (FullDetailsEmbedPage.EmbedDynamicPageLinkList[element]) {
          numOfSocials++;
        }
      });
      setNumOfSocialLinks(numOfSocials);
    }
  }, [FullDetailsEmbedPage]);

  const loadFormImages = () => {
    return formImages.map((item, i) => (
      <Image
        key={i}
        className="loading-embed-background"
        onLoad={() => setFormImagesLoaded((prev) => prev + 1)}
        src={item}
        alt=""
        title=""
      />
    ));
  };
  useEffect(() => {
    if (FullDetailsEmbedPage) {
      if (formImagesLoaded >= formImages.length) {
        setIsFormImagesLoaded(true);
      }
    }
  }, [formImagesLoaded, formImages, FullDetailsEmbedPage]);

  const openModalOrderTracker = () => {
    setModal({
      modal: OrderTrackerScript,
      modalSize: "full-modal",
      props: {
        brandingColor: brandingColor,
        isEmbedPage: true,
        isModal: true,
      },
    });
  };

  const accessabilityIcon = document.getElementById("userwayAccessibilityIcon");
  useEffect(() => {
    if (accessabilityIcon && accessabilityIcon !== undefined) {
      accessabilityIcon.style.bottom = "60px";
      if (diractionPage === "ltr") {
        accessabilityIcon.style.left = "unset";
        accessabilityIcon.style.right = "0px";
      } else {
        accessabilityIcon.style.left = "50px";
        accessabilityIcon.style.right = "unset";
      }
    }
  }, [diractionPage, accessabilityIcon]);

  if (!FullDetailsEmbedPage) {
    return null;
  }

  return (
    <div
      className={`embed-page-live-new ${!formSelected ? "carousel-mode" : ""} ${
        closeDescriptionMobile ? "close-mobile-description" : ""
      }`}
    >
      {randomBackground &&
        (isDefaultBackgrounds ? (
          <Image
            className="loading-embed-background"
            name={randomBackground}
            onLoad={() => setLoadImageBackground(true)}
            alt=""
            title=""
            ext="webp"
          />
        ) : (
          <Image
            className="loading-embed-background"
            src={randomBackground}
            alt=""
            title=""
            onLoad={() => setLoadImageBackground(true)}
          />
        ))}
      {formImages.length > 0 && loadFormImages()}
      {!loading && loadImageBackground && isFormImagesLoaded ? (
        FullDetailsEmbedPage &&
        FullDetailsEmbedPage.EmbedDynamicPage.EmbedPageActive &&
        FullDetailsEmbedPage.EmbedDynamicPage.EmbedPageStatusMode ===
          "publish" ? (
          <div className={`personal-branding-container`}>
            <div
              className={`personal-branding-body ${
                diractionPage === "rtl" ? "right-to-left" : "left-to-right"
              }`}
            >
              <div className="personal-branding-content">
                <SidePanel
                  numOfSocialLinks={numOfSocialLinks}
                  brandingColor={brandingColor}
                  setCloseDescriptionMobile={setCloseDescriptionMobile}
                  closeDescriptionMobile={closeDescriptionMobile}
                  openSidePanel={openSidePanel}
                  setOpenSidePanel={setOpenSidePanel}
                  FullDetailsEmbedPage={FullDetailsEmbedPage}
                  showCloseButton={showCloseButton}
                  formSelected={formSelected}
                  diractionPage={diractionPage}
                  displaySidePanel={displaySidePanel}
                />

                {formSelected === null ? (
                  <CarouselForms
                    userNamePage={userNamePage}
                    formList={formList}
                    setFormSelected={setFormSelected}
                    FullDetailsEmbedPage={FullDetailsEmbedPage}
                    pageLanguage={pageLanguage}
                  />
                ) : (
                  <SingleForm
                    brandingColor={brandingColor}
                    singleForm={singleForm}
                    clearFormDetails={clearFormDetails}
                    userNamePage={userNamePage}
                    formDetails={formDetails}
                    setFormDetails={setFormDetails}
                    embedIframe={embedIframe}
                    setEmbedIframe={setEmbedIframe}
                    openSidePanel={openSidePanel}
                    formList={formList}
                    setFormSelected={setFormSelected}
                    formSelected={formSelected}
                    FullDetailsEmbedPage={FullDetailsEmbedPage}
                    pageLanguage={pageLanguage}
                    displayFormDetails={displayFormDetails}
                  />
                )}
                <div className={`background-page`}>
                  {isDefaultBackgrounds ? (
                    <Image name={randomBackground} ext="webp" alt="" title="" />
                  ) : (
                    <Image src={randomBackground} alt="" title="" />
                  )}
                </div>
              </div>
              {!desktopCondition || !displaySidePanel ? (
                <div
                  className={`order-tracker-icon-tablet ${
                    formSelected ? "single-form" : ""
                  }`}
                >
                  <div
                    className={`order-tracker-text open`}
                    onClick={() => openModalOrderTracker()}
                  >
                    <div
                      className="order-tracker-image"
                      style={{ backgroundColor: brandingColor }}
                    >
                      <Image
                        name="personal/order-tracker-icon"
                        title=""
                        alt=""
                      />
                    </div>
                  </div>
                </div>
              ) : null}
              <EmbedPageFooter linkFooters={linkFooters} />
            </div>
            {/*Here just run the user scripts*/}
            {FullDetailsEmbedPage.EmbedDynamicPageScripts &&
              FullDetailsEmbedPage.EmbedDynamicPageScripts.EmbedPageScriptsStatus.toLowerCase() ===
                "approved" && (
                <UpdateScripts
                  bodyScript={
                    FullDetailsEmbedPage.EmbedDynamicPageScripts
                      .EmbedPageScriptBody
                  }
                  headScript={
                    FullDetailsEmbedPage.EmbedDynamicPageScripts
                      .EmbedPageScriptHead
                  }
                  setLoading={setLoading}
                />
              )}
          </div>
        ) : (
          <div className="empty-personal-page">
            <Err404 />
          </div>
        )
      ) : (
        <LoadingContainerElement />
      )}
    </div>
  );
};

export default NewEmbedPage;
